import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Stories from './pages/Stories';
import StoryDetail from './pages/StoryDetail';
import Players from './pages/Players';
import PlayerDetail from './pages/PlayerDetail';
import Login from './pages/Login';
import Register from './pages/Register';
import Write from './pages/Write';
import Profile from './pages/Profile';
import './styles/global.css';

const NAV_COLS = [
  {
    head: 'Explore',
    links: [
      { href: '/stories', label: 'All Stories' },
      { href: '/stories?type=personal', label: 'Personal Stories' },
      { href: '/stories?type=investigation', label: 'Investigations' },
      { href: '/stories?type=talent', label: 'Talent Spotlight' },
      { href: '/stories?type=interview', label: 'Interviews' },
    ],
  },
  {
    head: 'Community',
    links: [
      { href: '/players', label: 'Player Directory' },
      { href: '/register', label: 'Join the Platform' },
      { href: '/write', label: 'Write a Story' },
      { href: '/login', label: 'Sign In' },
    ],
  },
];

function Footer() {
  return (
    <footer className="footer">
      <div className="container" style={{ paddingTop: '3.5rem' }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: '2fr 1fr 1fr',
          gap: '3rem',
          flexWrap: 'wrap',
        }}>
          {/* Brand column */}
          <div>
            <div className="footer-brand">
              <div className="footer-logo">Pitch &amp; Pen</div>
              <span className="footer-sep">·</span>
              <div className="footer-powered">
                Powered by{' '}
                <a href="https://mistnex.co.zw" target="_blank" rel="noreferrer">
                  MistNex Dynamics
                </a>
              </div>
            </div>
            <p className="footer-tagline" style={{ maxWidth: 320, marginBottom: '1.5rem' }}>
              The platform where African football stories are told honestly — by players,
              journalists, scouts and fans across the continent.
            </p>
            {/* Social / links */}
            <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
              {[
                { href: 'https://mistnex.co.zw', label: '🌐 mistnex.co.zw' },
              ].map(s => (
                <a key={s.href} href={s.href} target="_blank" rel="noreferrer"
                  style={{
                    display: 'inline-flex', alignItems: 'center', gap: '0.35rem',
                    padding: '0.3rem 0.75rem', border: '1px solid rgba(255,255,255,0.1)',
                    borderRadius: 20, fontFamily: 'var(--font-sans)', fontSize: '0.78rem',
                    color: 'rgba(255,255,255,0.4)', transition: 'all 0.16s',
                    background: 'rgba(255,255,255,0.04)',
                  }}
                  onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--green)'; e.currentTarget.style.color = 'var(--green)'; }}
                  onMouseLeave={e => { e.currentTarget.style.borderColor = 'rgba(255,255,255,0.1)'; e.currentTarget.style.color = 'rgba(255,255,255,0.4)'; }}
                >
                  {s.label}
                </a>
              ))}
            </div>
          </div>

          {/* Nav columns */}
          {NAV_COLS.map(col => (
            <div key={col.head}>
              <div className="footer-nav-head">{col.head}</div>
              {col.links.map(l => (
                <a key={l.href} href={l.href} className="footer-nav-link">{l.label}</a>
              ))}
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div className="footer-bottom">
          <span className="footer-copy">
            © {new Date().getFullYear()} Pitch &amp; Pen. All rights reserved.
          </span>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
            <span className="footer-badge">
              <span>⚡</span> Built by <span>MistNex Dynamics</span>
            </span>
            <a href="https://mistnex.co.zw" target="_blank" rel="noreferrer"
              style={{
                fontFamily: 'var(--font-sans)', fontSize: '0.78rem',
                color: 'rgba(255,255,255,0.28)', transition: 'color 0.14s',
              }}
              onMouseEnter={e => e.target.style.color = 'var(--green)'}
              onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.28)'}
            >
              mistnex.co.zw →
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default function App() {
  return (
    <HelmetProvider>
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Navbar />
          <main style={{ minHeight: 'calc(100vh - var(--nav-h))' }}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/stories" element={<Stories />} />
              <Route path="/stories/:slug" element={<StoryDetail />} />
              <Route path="/players" element={<Players />} />
              <Route path="/talent" element={<Players />} />
              <Route path="/players/:id" element={<PlayerDetail />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/write" element={<Write />} />
              <Route path="/profile/:username" element={<Profile />} />
            </Routes>
          </main>
          <Footer />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
    </HelmetProvider>
  );
}
